// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sticky-total-price[data-v-4acb2a52]{display:block;position:relative;z-index:2}", ""]);
// Exports
module.exports = exports;
